import { theme } from 'antd';
import { HybridMap, Loader } from 'zComponents/atoms';
import { Button, Drawer, Form, Select, Space, Typography } from 'zui/Antd';

const { Text, Title } = Typography;

const instructions = [
	{
		key: 1,
		title: 'To update the current device location, click and drag the pin within the map.'
	},
	{
		key: 2,
		title: 'To add a new location, select the Floor and click on the new pin from the Top-Right corner.'
	},
	{
		key: 3,
		title: 'To remove the new location, click on the pin itself to remove it from the map.'
	}
];

function UpdateDeviceLocationDrawer({ deviceID = {}, open = false, setOpen }) {
	const [form] = Form.useForm();

	const {
		token: {
			colorText,
			paddingXL,
			paddingLG,
			controlItemBgActiveDisabled,

			colorTextLabel,
			fontWeightStrong,
			paddingXXS
		}
	} = theme.useToken();

	const site = deviceID?.site || { name: 'Zezamii - 8 Prospect Street, Fortitude Valley, QLD, 4029' };
	const handleCancel = () => {
		form.resetFields();
		setOpen(false);
	};

	const handleFinish = (values) => {
		handleCancel();
	};

	const numberCircle = {
		backgroundColor: controlItemBgActiveDisabled,
		width: 24,
		height: 24,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0
	};
	return (
		<Drawer
			placement='right'
			width='30%'
			onClose={() => setOpen(false)}
			open={open}
			destroyOnClose
			bodyStyle={{ padding: paddingXL }}
		>
			{/*will replace this hardcoded condition once start integration!*/}
			{false ? (
				<Loader />
			) : (
				<Space direction='vertical' size={paddingXL} style={{ width: '100%' }}>
					<Title level={4} style={{ margin: 0, color: colorText }}>
						Update Device Location
					</Title>

					<Space direction='vertical'>
						<Title
							level={5}
							style={{
								margin: 0,
								fontWeight: fontWeightStrong
							}}
						>
							How it works:
						</Title>
						<Space direction='vertical' size={16}>
							{instructions.map((instr, i) => (
								<Space key={i} align='start' size={12}>
									<div style={numberCircle}>
										<Text strong style={{ fontSize: 14, color: colorText }}>
											{i + 1}
										</Text>
									</div>
									<Text style={{ fontSize: 14, color: colorTextLabel }}>{instr.title}</Text>
								</Space>
							))}
						</Space>
					</Space>

					<Space direction='vertical' size={paddingLG} style={{ width: '100%' }}>
						<Space direction='vertical' size={paddingXXS}>
							<Text strong style={{ fontSize: 16, color: colorText }}>
								Site:
							</Text>
							<Text style={{ fontSize: 14, color: colorTextLabel }}>{site.name}</Text>
						</Space>

						<Form layout='vertical' onFinish={handleFinish}>
							<Form.Item
								name='floor'
								label={<span style={{ fontSize: 16, fontWeight: fontWeightStrong }}>Select Floor</span>}
								rules={[{ required: true, message: 'Please select a floor' }]}
							>
								<Select options={floorOptions} placeholder='Select Floor' />
							</Form.Item>

							<div style={{ maxHeight: '200px', overflow: 'hidden', marginBottom: '50px' }}>
								<HybridMap
									mapType='leaflet'
									data={{
										url: 'n/a',
										latitude: 37.7749,
										longitude: -122.4194
									}}
								/>
							</div>

							<Space direction='vertical' style={{ width: '100%' }}>
								<Button type='primary' key='submit' htmlType='submit' block>
									Save Changes
								</Button>
								<Button onClick={handleCancel} block>
									Cancel
								</Button>
							</Space>
						</Form>
					</Space>
				</Space>
			)}
		</Drawer>
	);
}

export default UpdateDeviceLocationDrawer;

const floorOptions = [
	{ label: 'Floor 1', value: 'floor1' },
	{ label: 'Floor 2', value: 'floor2' },
	{ label: 'Floor 3', value: 'floor3' },
	{ label: 'Floor 4', value: 'floor4' },
	{ label: 'Floor 5', value: 'floor5' }
];
